module.exports = {
  // API: heroku
  API: "http://localhost:8000",
};
